/**
 * IE11 tends to calculate numbers with very bad precision.
 * (For example, 1 + 2 becomes 2.99999999475, etc)
 * We try to fix this problem using Math.round, but it allows 0.25 precision.
 */
export function quantizeSize(size) {
    return Math.round(size * 4) / 4;
}
//# sourceMappingURL=utils.js.map